import type { Variant } from '@/api/types/graphql';
import type { TemplateInfo } from '../types/template';

import { ProviderSource, type BuildQueryParamsInAppV6 } from '../types/template';
import { convertTemplateTypeToGPV6, parseIdTemplate, parseTemplateInfoBy } from '../utils/template';

import useLocationHandlers from '@/composables/useLocationHandlers';

export const useEditTemplate = () => {
  const { handleOpenPageGPInNewTab } = useLocationHandlers();

  const handleEditTemplateV6 = ({ templateInfo }: { templateInfo: TemplateInfo }) => {
    if (!templateInfo) return;

    const templateId = parseIdTemplate(templateInfo.suffix, ProviderSource.GEMPAGESV6);
    if (!templateId) return;

    const pageType = convertTemplateTypeToGPV6(templateInfo.type);
    const url = buildQueryParamsInAppForV6({
      pageId: templateId,
      pageType: pageType,
      version: 'v6',
    });

    handleOpenPageGPInNewTab(url);
  };

  const buildQueryParamsInAppForV6 = ({ version, pageId, pageType }: BuildQueryParamsInAppV6) => {
    return `app/builder/${version}?pageId=${pageId}&type=${pageType}&version=${version}`;
  };

  const onEditWithTemplate = (variant: Variant) => {
    if (!variant?.templateSuffix) return;

    const templateInfo = parseTemplateInfoBy({
      templateSuffix: variant?.templateSuffix,
    });
    if (!templateInfo) return;

    if (templateInfo.providerSource === ProviderSource.GEMPAGESV6) {
      handleEditTemplateV6({ templateInfo });
      return;
    }
  };
  return { onEditWithTemplate };
};
